/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CoinInsights } from './CoinInsights';
import {
    CoinInsightsFromJSON,
    CoinInsightsFromJSONTyped,
    CoinInsightsToJSON,
} from './CoinInsights';

/**
 * 
 * @export
 * @interface CoinInsightsResponse
 */
export interface CoinInsightsResponse {
    /**
     * 
     * @type {CoinInsights}
     * @memberof CoinInsightsResponse
     */
    data?: CoinInsights;
}

/**
 * Check if a given object implements the CoinInsightsResponse interface.
 */
export function instanceOfCoinInsightsResponse(value: object): value is CoinInsightsResponse {
    let isInstance = true;

    return isInstance;
}

export function CoinInsightsResponseFromJSON(json: any): CoinInsightsResponse {
    return CoinInsightsResponseFromJSONTyped(json, false);
}

export function CoinInsightsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinInsightsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CoinInsightsFromJSON(json['data']),
    };
}

export function CoinInsightsResponseToJSON(value?: CoinInsightsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CoinInsightsToJSON(value.data),
    };
}

